import React, { useState } from "react";
import "./styles/OfferModal.css";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../dataManagement/uiDb/UiDb";
import { useKeyboardOffset } from "../../../../../hooks/useKeyboardOffset";

interface OfferModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOfferSuccess: (price: number) => void;
  onOfferCancel: () => void;
  initialPrice?: number;
}

const fetchSuggestedPrice = async (): Promise<number> => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(4999), 1000);
  });
};

const OfferModal: React.FC<OfferModalProps> = ({
  isOpen,
  onClose,
  onOfferSuccess,
  onOfferCancel,
  initialPrice,
}) => {
  const [suggestedPrice, setSuggestedPrice] = useState<number | null>(null);
  const [bidPrice, setBidPrice] = useState<number>(3000);

  React.useEffect(() => {
    if (initialPrice !== undefined) {
      setBidPrice(initialPrice);
    }
  }, [initialPrice, isOpen]);
  const [loading, setLoading] = useState(false);
  const generalDb = useSelector((state: RootState) => state.general);
  const keyboardOffset = useKeyboardOffset();

  if (!generalDb.makeOfferState.isMakeOfferOpen && !isOpen) return null;

  const handleSuggestPrice = async () => {
    setLoading(true);
    const price = await fetchSuggestedPrice();
    setSuggestedPrice(price);
    setBidPrice(price);
    setLoading(false);
  };

  return (
    <div className="nf-offer-overlay" onClick={onClose} style={{ paddingBottom: keyboardOffset }}>
      <div className="nf-offer-card" onClick={(e) => e.stopPropagation()}>
        <button
          onClick={() => onClose()}
          className="header-close-button"
          aria-label="Close"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6 6L18 18"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        {/* Header */}
        <h3 className="nf-offer-title">
          What price would you like to pay for this ?
        </h3>

        {/* Suggest Price Row */}
        {/* <div className="nf-suggest-row">
          <button
            className="nf-suggest-btn"
            onClick={handleSuggestPrice}
            disabled={loading}
          >
            {loading ? "Fetching..." : "Suggest Price"}
          </button>

          {suggestedPrice !== null && (
            <span className="nf-suggest-txt">Suggested: ₹{suggestedPrice}</span>
          )}
        </div> */}

        {/* Input */}
        <div className="nf-input-wrapper">
          <input
            type="decimal"
            min={100}
            max={100000}
            value={bidPrice}
            onChange={(e) => setBidPrice(parseInt(e.target.value))}
            onWheel={(e) => e.currentTarget.blur()}
            className="nf-offer-input"
            placeholder="Enter your price"
          />
        </div>

        {/* Buttons */}
        <div className="nf-btn-row">
          <button className="nf-btn-cancel" onClick={onOfferCancel}>
            Cancel
          </button>

          <button
            className="nf-btn-confirm"
            onClick={() => onOfferSuccess(bidPrice)}
          >
            Send message
          </button>
        </div>
      </div>
    </div>
  );
};

export default OfferModal;
